import { useLingui } from '@lingui/react/macro';
import React, { useEffect } from 'react';

export default function LangAttributeWrapper({ children }: React.PropsWithChildren<{}>) {
  // set the lang attribute on the html element
  const { i18n } = useLingui();
  useEffect(() => {
    document.documentElement.lang = i18n.locale;
  }, [i18n.locale]);

  return <>{children}</>;
}
